/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpinsights_Period_Thisyear3Inputs */

const en_coinvestments_lpinsights_period_thisyear3 = /** @type {(inputs: Coinvestments_Lpinsights_Period_Thisyear3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This year`)
};

/**
* | output |
* | --- |
* | "This year" |
*
* @param {Coinvestments_Lpinsights_Period_Thisyear3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpinsights_period_thisyear3 = /** @type {((inputs?: Coinvestments_Lpinsights_Period_Thisyear3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpinsights_Period_Thisyear3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpinsights_period_thisyear3(inputs)
});
export { coinvestments_lpinsights_period_thisyear3 as "coInvestments_lpInsights_period_thisYear" }